import { IUserCategoryBase } from '../../models/userCategories';
import {
  IUserAddressBase,
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
} from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUserAssignment extends IUserAssignmentBase {
  venture?: IVentureBase;
}

export interface INewUser extends IUserBase {
  address?: IUserAddressBase;
  categories: IUserCategoryBase[];
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

interface ICheckExistingUsersService {
  cpf?: string;
  email?: string;
  featureGroupId?: string;
  featureGroupKey?: string;
  foreignerDocument?: string;
  hostId?: string;
}

export const checkExistingUsersService = async ({
  cpf,
  email,
  featureGroupId,
  featureGroupKey,
  foreignerDocument,
  hostId,
}: ICheckExistingUsersService): Promise<void> => {
  await jhsfBookingsApi.post('/users/check-existing', {
    cpf,
    email,
    featureGroupId,
    featureGroupKey,
    foreignerDocument,
    hostId,
  });
};
